import * as types from 'store/mutation-types'
import Vue from 'vue'
import VueResource from 'vue-resource'
import {OPERATE_EXCEPTION} from 'static/message.js'
Vue.use(VueResource)


function timeToSec(num){
		let str = num + ''
		//let sec = 0;
		let h = parseInt(str.substring(6,8));
		let m = parseInt(str.substring(8,10));
		let s = parseInt(str.substring(10));
		//let totalSec = 0;
		return h * 3600 + m * 60 + s;
}


// initial state
const state = {
	/*和loading有关*/
	loadinglist:false,	//轨迹队列load
	loadingPosi:false,	//切换上下定位点时
	loadingCa:false,	//日历load
	/*-跟日历有关-*/
	newDay:{},			//从日历上选定的新日期信息
	curDeviceObj:{},	//当前日历对应的轨迹队列车辆信息  
	calendar: false,	//是否显示日历控件
	hasTrackDate:[],	//某月有轨迹的日期
	/*-公共-*/
	showModal:false, //默认不显示提示弹框
	tipContent:'',      //提示弹框的内容
	showWithdraw:false,	//提示框是否显示取消按钮
	mapShowType:5,		//判断是查看定位点、轨迹回放还是报警现场
	clearTheOld:true,	//清空重绘模式开启
	clearTheMap:false,	//清空地图（清空重绘模式下，地图上的内容为待删除队列时）
	delTheChosen:[],   //删除选中的队列id（同时要删除对应的地图内容）
	delTheAll:false,	//是否删除所有队列（同时清空地图）
	/*-和轨迹队列有关-*/
	traceListInfo:{},	//左侧轨迹队列数据
	totalTraceList:[],  //所有的轨迹队列数据
	checkedArr:[],
	openFrom:0,			//是通过点菜单打开0，还是通过追加轨迹打开1
//	isChecked:false, 	//默认复选框非选中状态	
	/*-和查看定位点有关-*/
	positionList:[],	//定位点数据集合 -> 用于获取前后定位点
//	vehiclePoint:{},	//车辆对应的地图坐标->用于显示到地图上
	locateInfo:{},		//车辆对应的位置信息->用于地图定位窗口显示
	vehiInfo:{},		//车辆对应的车辆信息
	/*-跟报警现场有关-*/
	almInfoObj:{},		//某天对应的报警信息
	/*-跟轨迹回放有关-*/
	trackInfoList: [],	//某天对应的轨迹信息
	rescueEventList: [],//救援轨迹的事件列表
	trackId:'',
	hasTrackDay:'',		//上一个或下一个有轨迹的日期
	trackIdArr:[],
	trackDateArr:[],
	traceRecord:{},		//行车记录 =>填充vehicleInfo组件
	momentTrack:{},		//后台实际是对象（时间轴上对应的某个位置的轨迹）
	ballMoved:false,
	xVal:0,       		//时间轴移动时改变的x轴值
	hasTrackXval:0,		//时间轴上有轨迹的x轴值
	unitX:0,	  		//存时间轴每30s移动的X值（VehiclePlay播放组件用）
	endX:0,				//存时间轴结束时的X值（VehiclePlay播放组件用）
	startX:0,			//存时间轴起始X值（VehiclePlay播放组件用）
	stopIndex:[],	//停车时的索引
	showInfoComp:false,	//显示VehicleInfo组件
	carId:'',			//被查看轨迹的车辆id
	moveFlag:false,
	isDragging:false,	//进度条是否被拖拽中
	isPlaying:false		//是否正在播放轨迹，若正在播放轨迹，则把左侧轨迹队列面板的变为半透明
}

//getters
const getters = {
	travels:state=>{//将当天轨迹分段
		let pois = state.trackInfoList
		let travels = []
		state.stopIndex = [] //每回切换要把之前数据清空
		if(pois && pois.length > 0) {
			let diffTime = 0;
			let tmpTravel = [];
			let pre = pois[0].gpsTime;
			let preTime = timeToSec(pre) / 60
			for(let i = 0; i <= pois.length - 1; i++) {
				let time = pois[i].gpsTime;
				let locTime = timeToSec(time) / 60;
				diffTime = locTime - preTime;
				// 两点之间相隔5分钟 进行分段处理
				if(!(diffTime < 5)) {
					state.stopIndex.push(i);
					travels.push(tmpTravel);
					tmpTravel = [];
				}
				tmpTravel.push(pois[i]);
				preTime = locTime;
			};
			if(tmpTravel.length > 0) {
				travels.push(tmpTravel);
			}
		}
		return travels
	}
}

// actions
const actions = {
	loadingFinish({commit}){
		commit(types.HIDE_LOADING)
	},
	loadingStart({commit}){
		commit('showLoading')
	},
	loadPosi({commit}){
		commit(types.LOAD_POSI)
	},
	/*-共用-弹框-*/
	showModal({commit},obj){
		commit(types.SHOW_MODAL,obj)
	},
	hideModal({commit}){//隐藏弹框
		commit(types.HIDE_MODAL)
	},
	/*和日历有关的操作*/
	showCalendar({commit}) { //显示日历
		commit(types.SHOW_CALENDAR)
	},
	hideCalendar({commit}) { //隐藏日历
		commit(types.HIDE_CALENDAR)
	},
	getDeviceInfo({commit},deviceObj){
		commit(types.GET_DEVICE_INFO,deviceObj)
	},
	getNewMonthTrace({commit},param){//点击日历前后年份和月份=>获取切换后的月份中有轨迹的日期和当日总里程数
		commit(types.GET_NEW_MONTH_TRACE,param)
	},
	setSelectedDay({commit},obj){
		commit(types.SET_TRACE_DAY,obj)
	},
	/*和轨迹队列有关的操作 */
	getTraceList({commit},num){//获取轨迹队列-包括救援轨迹
		commit(types.GET_TRACELIST,num)
	},
	getTraces({commit},num){
		commit('showLoading')
		Vue.http.get(process.env.API_ROOT + '/trace/traces/',{params:{page_index:num}})
		.then(res=>{
			commit(types.HIDE_LOADING)
			commit('getVehicleListInfo',res.body.data)
		},res=>{
			commit(types.HIDE_LOADING)
			let tip = !res.body.message?'获取或刷新轨迹队列失败，请稍后重试':res.body.message 
			commit(types.SHOW_MODAL,{tipCnt:tip,showBtn:false})
		})
	},
	getCheckedVehicle({commit},id){//获取选中要被删除的车辆集合
		commit(types.GET_CHECKED,id)
	},
	removeCheckedVehicle({commit},id){//反选选中要被删除的车辆集合
		commit(types.REMOVE_CHECKED,id)
	},
	setCheckbox({commit}){//设置、改变、更新复选框选中状态
		commit(types.SET_CHECKBOX)
	},
	reCheckbox({commit}){
		commit(types.RE_CHECKBOX)
	},
	delChosen({commit}){
		commit(types.DEL_CHOSEN)
	},
	deleteTraceList({commit},obj){//删除轨迹队列 
		commit('showLoading')
		return new Promise(function(resolve,reject){
			Vue.http.delete(process.env.API_ROOT + '/trace/traces/',{body:obj.arr})
			.then((response) => {
				commit(types.HIDE_LOADING)
				commit(types.DEL_TRACELIST,obj)
				resolve()
			}, (response) => { 
				commit(types.HIDE_LOADING)
				let tip = !response.body.message?'删除操作失败，请稍后重试':response.body.message 
				commit(types.SHOW_MODAL,{tipCnt:tip,showBtn:false})
			})
		})
	},
	deleteAll({commit}){//点击清空队列
		commit('showLoading')
		return new Promise(function(resolve,reject){
			Vue.http.delete(process.env.API_ROOT + '/trace/traces/')
			.then( res => {
				commit(types.DEL_ALL)
				commit(types.HIDE_LOADING) 
				resolve()
			}, res => {
				commit(types.HIDE_LOADING)
				let tip = !res.body.message?'清空队列失败，请稍后重试':res.body.message 
				commit(types.SHOW_MODAL,{tipCnt:tip,showBtn:false})
			})
		}) 
	},
	updateLockFlag({commit},obj){//更新锁定状态
		commit(types.UP_LOCKFLAG,obj)
	},
	addLocatePoint({commit},obj){//追加定位点-迪迪客服才可以
		commit('setOpenFrom',1)
		commit('showLoading')
		Vue.http.post(process.env.API_ROOT + '/trace/traces/positions',obj)
		.then((response) => {
			if(response.body.data){ 
				commit(types.HIDE_LOADING)
				commit('getVehicleListInfo',response.body.data)
				commit(types.SHOW_MODAL,{tipCnt:'追加轨迹队列成功',showBtn:false})
			}
		},(response)=>{
			commit(types.HIDE_LOADING)
			let tip = !res.body.message?'追加队列失败，请稍后重试':response.body.message 
			commit(types.SHOW_MODAL,{tipCnt:tip,showBtn:false})
		})
	},
	addTrackList({commit},param){//追加到轨迹队列--车辆--type=4(最新轨迹)
		commit('showLoading')
		commit('setOpenFrom',1)
		return new Promise(function(resolve,reject){
			Vue.http.post(process.env.API_ROOT + '/trace/traces/gps?type=' + param.type,param.vehicleIds)
			.then((response) => {
				commit(types.HIDE_LOADING)
				commit(types.SHOW_MODAL,{tipCnt:'追加轨迹队列成功',showBtn:false})
				resolve()
			},(response)=>{
				commit(types.HIDE_LOADING)
				let tip = !response.body.message?'追加轨迹队列失败，请稍后重试':response.body.message 
				commit(types.SHOW_MODAL,{tipCnt:tip,showBtn:false})
			})
		}) 
	},
	addTrackHistory({commit},param){//追加历史轨迹-type=3--只有迪迪客服可以
		commit('setOpenFrom',1)
		commit('showLoading')
		Vue.http.post(process.env.API_ROOT + '/trace/traces/gps?type=' + param.type + '&gpsTime=' + param.gpsTime + '&deviceId=' + param.deviceId,param.vehicleIds)
		.then((response) => {
			if(response.body.data){
				commit(types.HIDE_LOADING)
				commit('getVehicleListInfo',response.body.data)
				commit(types.SHOW_MODAL,{tipCnt:'追加轨迹队列成功',showBtn:false})
			}
		},(response)=>{
			commit(types.HIDE_LOADING)
			let tip = !response.body.message?'追加轨迹队列失败，请稍后重试':response.body.message 
			commit(types.SHOW_MODAL,{tipCnt:tip,showBtn:false})
		})
	},
	//追加到轨迹队列-分支
	allTrackList({commit},param){//左侧树分支追加轨迹
		commit('setOpenFrom',1)
		commit('showLoading')
		return new Promise(function(resolve,reject){
			Vue.http.post(process.env.API_ROOT + '/trace/traces/gps/group/'+ param.groupId + '?treeType=' + param.treeType + '&vehicleParam=' + param.vehicleParam)
			.then((response) => {
				commit(types.HIDE_LOADING)
				commit(types.SHOW_MODAL,{tipCnt:'添加分支轨迹成功',showBtn:false})
				resolve()
			},(response)=>{
				commit(types.HIDE_LOADING)
				let tip = !response.body.message?'追加轨迹队列失败，请稍后重试':response.body.message 
				commit(types.SHOW_MODAL,{tipCnt:tip,showBtn:false})
			}) 
		})
		
	},
	trackAll({commit}, param){ //底部面板追加轨迹--只有迪迪客服可以
		commit('setOpenFrom',1)
		commit('showLoading')
		return new Promise(function(resolve,reject){
			Vue.http.post(process.env.API_ROOT + '/trace/traces/gps/monitor' + '/' + param.tagpanelId)
			.then((response) => { 
				commit(types.HIDE_LOADING)
				commit(types.SHOW_MODAL,{tipCnt:'添加轨迹成功',showBtn:false})
				resolve()
			},(response)=>{
				commit(types.HIDE_LOADING)
				let tip = !response.body.message?'追加轨迹队失败，请稍后重试':response.body.message 
				commit(types.SHOW_MODAL,{tipCnt:tip,showBtn:false})
			})
		}) 
	},
	//追加到轨迹队列-报警现场-车辆
	addAlarmLive({commit},param){
		commit(types.ADD_ALARM_LIVE,param)
	},
	clearBeforeDraw({commit},bool){//清空重绘模式
		commit(types.CLEAR_BEFORE_DRAW,bool)
	},
	/*和报警现场有关的操作*/
	getAlarmInfo({commit},alarmObj){//获取某天的报警现场
		commit(types.GET_DAY_ALARMDATA,alarmObj)
	},
	/*和查看定位点有关的操作 */ 
	setPosition({commit},positionObj){//将车辆定位点显示到地图上
		commit(types.SET_VEHICLE_POSITION,positionObj)
	},
	/*和轨迹回放有关的操作 */
	getTrackInfo({commit},trace) { //获取某天的轨迹信息
		commit(types.GET_DAY_TRACKDATA,trace)
	},
	getPreNextTrack({commit},clickObj){//获取前后有轨迹的日期
		commit(types.PRE_NEXT_TRACKDATE,clickObj)
	},
	hasTrackX({commit},hasX){
		commit(types.HAS_TRACK_X,hasX)
	},
	getXval({commit},vals){//获取随着时间轴移动而改变的时间
		commit(types.GET_XAXIS_VALUE,vals)
	},
	saveStartX({commit},val){//存时间轴起始X值
		commit(types.SAVE_STARTX,val)
	},
	saveUnitX({commit},val){//存时间轴每30s移动的X值
		commit(types.SAVE_UNITX,val)
	},
	saveEndX({commit},val){//存时间轴结束时的X值
		commit(types.SAVE_ENDX,val)
	},
	getMomentTrack({commit},info){//获取时间轴上某时刻对应的轨迹信息
		commit(types.GET_MOMENT_TRACK,info)
	},
	initMap({commit}){
		commit(types.INIT_MAP)
	},
	moveFlag({commit}){
		commit(types.MOVE_FLAG)
	},
	setDragging({commit},val){
		commit(types.SET_DRAGGING,val)
	},
	setPlaying({commit},val){
		commit(types.SET_PLAYING,val)
	},
	/*救援轨迹相关 */
	getRescueTrack({commit},trace) {
		commit(types.GET_RESCUE_TRACK,trace)
	}
}

// mutations
const mutations = {
	setOpenFrom(state,source){
		state.openFrom = source;
	},
	showLoading(state){
		state.loadinglist = true;
	},
	[types.HIDE_LOADING](state){
		state.loadinglist = false;
		state.loadingCa = false;
	},
	[types.LOAD_POSI](state){
		state.loadingPosi = true;
		clearInterval(timer)
		let timer = setInterval(function(){
			state.loadingPosi = false;
		},1000)
	},
	/*-共用-弹框-*/
	[types.SHOW_MODAL](state,obj){//隐藏弹框
		state.showModal = true;
		state.tipContent = obj.tipCnt;
		state.showWithdraw = obj.showBtn;
	},
	[types.HIDE_MODAL](state){//隐藏弹框
		state.showModal = false;
		state.showWithdraw = false;
	},
	/*和日历有关的方法*/
	[types.SHOW_CALENDAR](state) {//显示日历
		state.calendar = true
	},
	[types.HIDE_CALENDAR](state) {//隐藏日历
		state.calendar = false
	},
	[types.GET_DEVICE_INFO](state,deviceObj){
		state.curDeviceObj = deviceObj 
	},
	[types.GET_NEW_MONTH_TRACE](state,param){//获取前、后年月份的轨迹信息// /trace/calendar/yearMonth
		state.loadingCa = true
		Vue.http.get(process.env.API_ROOT + '/trace/calendar/yearMonth',{params:param})
		.then((response) => {
			state.loadingCa = false 
			if(response.body.data.length > 0){
				state.hasTrackDate = response.body.data
				
			}
		}, (response) => {
			state.loadingCa = false
			state.showModal = true;
			state.showWithdraw = false;
			if(response.body.message) {
				state.tipContent = response.body.message;
				state.hasTrackDate = []
			} else {
				state.tipContent = OPERATE_EXCEPTION;
			}
		})
		.catch((response) => {
			state.loadingCa = false
			state.showModal = true;
			state.showWithdraw = false;
			state.tipContent = OPERATE_EXCEPTION;
		})
	},
	[types.SET_TRACE_DAY](state,obj){
		state.newDay = obj
		state.calendar = false
		//更新后台字段（post请求）
		const param = {
			day:obj.day,
			traceId:state.curDeviceObj.traceId
		} 
		mutations.POST_NEW_DAY(state,param)
	}, 
	[types.POST_NEW_DAY](state,obj){
		let dateStr = obj.day
		const dayNum = dateStr.split('-')[2]
		const monNum = dateStr.split('-')[1]
		const yearNum = dateStr.split('-')[0]
		obj.day = yearNum + monNum + dayNum
		Vue.http.post(process.env.API_ROOT + '/trace/calendar/day',obj,{emulateJSON:true})
		.then(res=>{
			
		},res=>{
			state.showModal = true;
			state.showWithdraw = false;
			state.loadinglist = false
			if(res.body.message) {
				state.tipContent = res.body.message;
			} else {
				state.tipContent = OPERATE_EXCEPTION;
			}
		})
		.catch(res=>{
			state.showModal = true;
			state.showWithdraw = false;
			state.tipContent = OPERATE_EXCEPTION;
		})
	},
	/*和轨迹队列有关的方法 */
	getVehicleListInfo(state,info){
		state.clearTheMap = false
		state.traceListInfo = info
		if(state.traceListInfo != null && state.traceListInfo.list.length != 0){
			state.delTheAll = false;
			let arr = state.traceListInfo.list
			for(let i = 0,length = arr.length; i < length; i ++){
				let tmpIndex = state.totalTraceList.findIndex(n=>n.id == arr[i].id)
				if(tmpIndex == -1){
					arr[i].isChecked = false
					state.totalTraceList.push(arr[i])
				}else{
					arr[i].isChecked = state.totalTraceList[tmpIndex].isChecked
				}
			}
		}else{
			state.totalTraceList = []
		} 
	},
	[types.GET_TRACELIST](state,num){//获取轨迹队列////'../../../static/vehicletrace/tracelist.json'
		state.loadinglist = true
		Vue.http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/trace/traces',{params:{page_index:num}})
		.then((response) => { 
				state.clearTheMap = false
				state.traceListInfo = response.body.data
				if(state.traceListInfo != null && state.traceListInfo.list.length != 0){
					state.delTheAll = false;
					let arr = state.traceListInfo.list
					for(let i = 0,length = arr.length; i < length; i ++){
						let tmpIndex = state.totalTraceList.findIndex(n=>n.id == arr[i].id)
						if(tmpIndex == -1){
							arr[i].isChecked = false
							state.totalTraceList.push(arr[i])
						}else{
							arr[i].isChecked = state.totalTraceList[tmpIndex].isChecked
						}
					}
				}else{
					state.totalTraceList = []
				} 
			state.loadinglist = false
		}, (response) => {
			state.showModal = true;
			state.showWithdraw = false;
			state.loadinglist = false
			if(response.body.message) {
				state.tipContent = response.body.message;
			} else {
				state.tipContent = OPERATE_EXCEPTION;
			}
		})
	},
	[types.GET_CHECKED](state,id){//获取选中要被删除的车辆集合
		let tmpI = state.checkedArr.findIndex(n=>n==id)
		if(tmpI == -1){
			state.checkedArr.push(id)
			
			let i = state.traceListInfo.list.findIndex(n=>n.id==id)
			state.traceListInfo.list[i].isChecked = true
			state.traceListInfo.list.splice(i,1,state.traceListInfo.list[i])
			
			let index = state.totalTraceList.findIndex(n=>n.id==id)
			state.totalTraceList[index].isChecked = true
			state.totalTraceList.splice(index,1,state.totalTraceList[index]);
		}
	},
	[types.REMOVE_CHECKED](state,id){//反选选中要被删除的车辆集合
		let index = state.checkedArr.findIndex(n=>n===id);
		if(index != -1){
			state.checkedArr.splice(index,1);
			
			let i = state.traceListInfo.list.findIndex(n=>n.id==id)
			state.traceListInfo.list[i].isChecked = false
			state.traceListInfo.list.splice(i,1,state.traceListInfo.list[i])
			
			let index1 = state.totalTraceList.findIndex(n=>n.id==id);
			state.totalTraceList[index1].isChecked = false;
			state.totalTraceList.splice(index1,1,state.totalTraceList[index1]);
		}
	},
	[types.SET_CHECKBOX](state){//全选
		for(let i = 0,length = state.traceListInfo.list.length; i < length; i ++){ 
			mutations.GET_CHECKED(state,state.traceListInfo.list[i].id)
		}
	},
	[types.RE_CHECKBOX](state){//反选
		for(let i = 0,length = state.traceListInfo.list.length; i < length; i ++){
			if(state.traceListInfo.list[i].isChecked){ 
				mutations.REMOVE_CHECKED(state,state.traceListInfo.list[i].id)
			}else{ 
				mutations.GET_CHECKED(state,state.traceListInfo.list[i].id)
			}
			
		}
	},
	[types.DEL_CHOSEN](state){
		state.delTheChosen = []
	},
	[types.DEL_TRACELIST](state,obj){//删除轨迹队列//'/trace/traces/'
		state.totalTraceList = []
		if(state.traceListInfo != null && state.traceListInfo.list.length != 0){
			const traceArr = state.traceListInfo.list;
			let arr = obj.arr
			for(let j = 0,len = arr.length; j < len; j ++){
				let i = traceArr.findIndex(n=>n.id==arr[j])
				if(state.clearTheOld){//选中
					if(state.trackId == arr[j]){
						state.clearTheMap = true;
					}
				}else{//非选中	
					state.delTheChosen.push({id:traceArr[i].id,type:traceArr[i].showType})
				} 
			}
		}
		state.checkedArr = [] 
		for(let i = 0,len = state.traceListInfo.list.length; i < len; i ++){
			state.traceListInfo.list[i].isChecked = false;
		}
	},
	[types.DEL_ALL](state){//点清空队列--锁定车辆除外
		state.totalTraceList = []
		if(state.traceListInfo != null && state.traceListInfo.list.length != 0){
			let arr = state.traceListInfo.list
			for(let i = 0,length = arr.length; i < length; i ++){
				if(arr[i].lockFlg === 0 && arr[i].id == state.trackId){
					//清空地图
					state.delTheAll = true;
					state.showInfoComp = false
				}
			}
		}
		state.checkedArr = [] 
		for(let i = 0,len = state.traceListInfo.list.length; i < len; i ++){
			state.traceListInfo.list[i].isChecked = false;
		}
	},
	[types.UP_LOCKFLAG](state,obj){//更新锁定状态
		Vue.http.post(process.env.API_ROOT + '/trace/traces/' + obj.listId + '/lock?lockFlg=' + obj.isLocked)
		.then((response) => {
//			state.showModal = true;
//			state.showWithdraw = false;
//			state.tipContent = '操作成功';
		}, (response) => {
			state.showModal = true;
			state.showWithdraw = false;
			if(response.body.message) {
				state.tipContent = response.body.message;
			} else {
				state.tipContent = OPERATE_EXCEPTION;
			}
		})
	},
	[types.ADD_ALARM_LIVE](state,param){
		//'/trace/traces/alarms',param
		//'/trace/traces/alarms?almMsgId=' + param.almMsgId + '&vehicleId=' + param.vehicleId
		Vue.http.post(process.env.API_ROOT + '/trace/traces/alarms',param)
		.then((response) => {
			if(response.body.success){
				mutations.GET_TRACELIST(state,1)
			}else{
				state.showModal = true
				state.showWithdraw = false;
				state.tipContent = response.body.message		
			}
		},(response)=>{
				state.showModal = true
				state.showWithdraw = false;
				state.tipContent = OPERATE_EXCEPTION	
		})
		.catch((response)=>{
				state.showModal = true
				state.showWithdraw = false;
				state.tipContent = OPERATE_EXCEPTION	
		})
	},
	[types.CLEAR_BEFORE_DRAW](state,bool){//清空重绘模式是否开启
		state.clearTheOld = bool;
	},
	/*和报警现场有关的方法*/
	[types.GET_DAY_ALARMDATA](state,alarmObj){//获取某天的报警现场信息//'/trace/traces/alarms/' + id
		const id = alarmObj.id;
		state.loadinglist = true
		state.showInfoComp = false;
		
		Vue.http.get(process.env.API_ROOT + '/trace/traces/alarms/' + id )
		.then((response) => {
			state.vehiInfo = {
				vInfo:alarmObj.vehiInfo,
				vId:alarmObj.id,
				uni:alarmObj.uni
			}
			state.loadinglist = false
			state.mapShowType = alarmObj.showType;
			const traceObj = response.body.data;
			state.almInfoObj = {
				almLng:traceObj.lng,
				almLat:traceObj.lat,
				almPoints:traceObj.points
			};
			state.traceRecord = traceObj.traceRecord;
			state.showInfoComp = true; 
			state.trackId = traceObj.id
			state.trackInfoList = traceObj.gpsInfoList;
		}, (response) => {
			state.loadinglist = false
			state.showModal = true;
			state.showWithdraw = false;
			state.trackId = ''
			if(response.body.message) {
				state.tipContent = response.body.message;
			} else {
				state.tipContent = OPERATE_EXCEPTION;
			}
		})
		.catch((response) => {
			state.loadinglist = false
			state.showModal = true;
			state.showWithdraw = false;
			state.tipContent = OPERATE_EXCEPTION;
		})
	},
	/*和查看定位点有关的方法 */
	[types.SET_VEHICLE_POSITION](state,positionObj){//设置车辆定位点
		state.locateInfo = positionObj.info
		state.vehiInfo = {
				vInfo:positionObj.vehicleInfo,
				vId:positionObj.vId,
				uni:positionObj.uni
			}
		state.trackId = positionObj.vId
		state.mapShowType = positionObj.showType
	},
	// 救援轨迹相关
	[types.GET_RESCUE_TRACK](state,trace) {
		state.loadinglist = true
		state.showInfoComp = false;
//		Vue.http.get("../../../static/vehicletrace/vehicletrace1.json")
		Vue.http.get(process.env.API_INSURANCE_ROOT + "/rescue-api/trace/traces/rescue/" + trace.id)
			.then(response => {
				state.vehiInfo = {
					vInfo:trace.vehiInfo,
					vId:trace.id,
					uni:trace.uni
				}
				if(response.body.data) {
					const traceObj = response.body.data
					state.traceRecord = traceObj.traceRecord;
					state.rescueEventList = traceObj.rescueEventList;
					
					// 去掉多余的停车点
					let pois = traceObj.gpsInfoList;
					let trackList = [];
					for(let i = 0; i < pois.length; i++){
						let item = pois[i];
						if(item.status.indexOf('停车') === -1){
							trackList.push(item);
						} 
						else {
							if(i === pois.length - 1){
								continue;
							} else {
								if(pois[i + 1].status.indexOf('停车') === -1){
									trackList.push(item);
								}
							}
						}
					}
					state.trackInfoList = trackList;
					
//					state.trackInfoList = traceObj.gpsInfoList;
					state.mapShowType = trace.showType;
					state.trackId = traceObj.id
					state.showInfoComp = true;
					state.loadinglist = false;
					state.vehiInfo.showCarType = traceObj.showCarType;
				}
			}, response => {
				state.showModal = true;
				state.showWithdraw = false;
				state.loadinglist = false
				state.trackId = ''
				if(response.body) {
					state.tipContent = response.body.message;
					state.showInfoComp = false
				} else {
					state.tipContent = OPERATE_EXCEPTION;
				}
			})
	},
	/*和轨迹回放有关的方法 */
	[types.GET_DAY_TRACKDATA](state,trace) {//获取某天的轨迹信息'../../../static/vehicletrace/testtrack.json'
		state.loadinglist = true
		state.showInfoComp = false;
		//'../../../../static/vehicletrace1.json'
		//process.env.API_ROOT + '/trace/traces/gps/' + trace.id + '?dateStr=' + trace.dateStr
		Vue.http.get(process.env.API_ROOT + '/trace/traces/gps/' + trace.id + '?dateStr=' + trace.dateStr)
			.then((response) => {
				state.vehiInfo = {
					vInfo:trace.vehiInfo,
					vId:trace.id,
					uni:trace.uni
				}
				/*const traceObj = response.body.content
					state.traceRecord = traceObj.traceRecord;
					state.trackInfoList = traceObj.gpsInfoList	
					state.mapShowType = trace.showType;
					state.trackId = traceObj.id
					state.showInfoComp = true;
					state.loadinglist = false*/
				if(response.body.data) {
					const traceObj = response.body.data
					state.traceRecord = traceObj.traceRecord;
//					state.trackInfoList = traceObj.gpsInfoList	

					// 去掉多余的停车点
					let pois = traceObj.gpsInfoList;
					let trackList = [];
					for(let i = 0; i < pois.length; i++){
						let item = pois[i];
						if(item.status.indexOf('停车') === -1){
							trackList.push(item);
						} 
						else {
							if(i === pois.length - 1){
								continue;
							} else {
								if(pois[i + 1].status.indexOf('停车') === -1){
									trackList.push(item);
								}
							}
						}
					}
					state.trackInfoList = trackList;

					state.mapShowType = trace.showType;
					state.trackId = traceObj.id
					state.showInfoComp = true;
					state.loadinglist = false
				} else {
					state.showModal = true;
					state.showWithdraw = false;
					state.tipContent = '历史轨迹信息为空';
					state.loadinglist = false
				}
			}, (response) => {
				state.showModal = true;
				state.showWithdraw = false;
				state.loadinglist = false
				state.trackId = ''
				if(response.body) {
					state.tipContent = response.body.message;
					state.showInfoComp = false
				} else {
					state.tipContent = OPERATE_EXCEPTION;
				}
			})
			.catch((response) => {
				state.loadinglist = false
				state.showModal = true;
				state.showWithdraw = false;
				state.tipContent = OPERATE_EXCEPTION;
			})
	},
	[types.PRE_NEXT_TRACKDATE](state,param){//获取前后有轨迹的日期// /trace/calendar/day
		state.carId = param.vehicleId;
		Vue.http.get(process.env.API_ROOT + '/trace/calendar/day',{params:param})
		.then((response) => {
			if(response.body.data){
				const obj = response.body.data
				state.hasTrackDay = obj.date
				//更新后台字段（post请求）
				const newParam = {
					day:obj.date.split(' ')[0],
					traceId:param.traceId
				}
				mutations.POST_NEW_DAY(state,newParam) 
			}
		}, (response) => {
			state.showModal = true;
			state.showWithdraw = false;
			if(response.body.message) {
				state.tipContent = response.body.message;
			} else {
				state.tipContent = OPERATE_EXCEPTION;
			}
		})
		.catch((response) => {
			state.showModal = true;
			state.showWithdraw = false;
			state.tipContent = OPERATE_EXCEPTION;
		})
	},
	[types.HAS_TRACK_X](state,hasX){
		state.hasTrackXval = hasX
	},
	[types.GET_XAXIS_VALUE](state,vals){//获取随着时间轴移动而改变的时间
		state.xVal = vals;
	},
	[types.SAVE_STARTX](state,val){//存时间轴起始X值
		state.startX = val;
	},
	[types.SAVE_ENDX](state,val){//存时间轴结束时的X值
		state.endX = val;
	},
	[types.SAVE_UNITX](state,val){//存时间轴每30s移动的X值
		state.unitX = val;
	},
	[types.GET_MOMENT_TRACK](state,info){//获取时间轴上某时刻对应的轨迹信息
		state.momentTrack = info
		state.ballMoved = true
	},
	[types.INIT_MAP](state){
		state.traceRecord = {}
		state.trackId = ''
		state.showInfoComp = false
		state.clearTheOld = true
		state.checkedArr = []
		if(state.totalTraceList.length > 0){
			for(let i = 0,len = state.totalTraceList.length; i < len; i ++){
				state.totalTraceList[i].isChecked = false;
			}
			for(let i = 0,len = state.traceListInfo.list.length; i < len; i ++){
				state.traceListInfo.list[i].isChecked = false;
			}
		}
		
		
	},
	[types.MOVE_FLAG](state){
		state.moveFlag = true
	},
	[types.SET_DRAGGING](state,val){
		state.isDragging = val
	},
	[types.SET_PLAYING](state,val){
		state.isPlaying = val
	},
}

export default {
	state,
	actions,
	mutations,
	getters
}




// WEBPACK FOOTER //
// ./src/store/modules/vehicle.js